import { render } from "./ContentLayout.vue?vue&type=template&id=24fbe456&scoped=true"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"

import "./ContentLayout.vue?vue&type=style&index=0&id=24fbe456&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fbe456"]])

export default __exports__